// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"94ea1dd5","488":"94ea1dd5","517":"e8bdd979"}[chunkId] + ".chunk.css";
};